/* Stylesheet */

.link_button {
  margin: 21px 0px 21px 0px;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}

.disabled {
  .label {
    color: #3b4c65;
  }

  &:hover {
    text-decoration: none;
    cursor: default;
  }
}
